import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OliCard = ({ oli, onConsult, onViewDetails }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(price);
  };

  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-card-hover hover:shadow-honda-glow transition-all duration-300 group">
      <div className="relative h-60 md:h-64 mb-4 bg-muted flex items-end justify-center overflow-hidden">
        <Image
          src={oli?.image}
          alt={oli?.imageAlt}
          className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
        />

        {oli?.isGenuine && (
          <div className="absolute top-3 left-3 bg-primary text-primary-foreground px-3 py-1 rounded-full flex items-center space-x-1 shadow-honda-subtle">
            <Icon name="Shield" size={14} />
            <span className="text-xs font-heading font-bold">Genuine Honda</span>
          </div>
        )}
        {/* {oli?.stock === 0 && (
          <div className="absolute inset-0 bg-secondary/80 flex items-center justify-center">
            <span className="text-secondary-foreground font-heading font-bold text-lg">Stok Habis</span>
          </div>
        )} */}
        {oli?.isNew && (
          <div className="absolute top-3 right-3 bg-success text-success-foreground px-3 py-1 rounded-full">
            <span className="text-xs font-heading font-bold">Baru</span>
          </div>
        )}
      </div>
      <div className="p-3 pt-1">
        <div className="mb-1">
          <span className="text-[11px] text-muted-foreground font-medium">
            {oli?.category}
          </span>
          <h3 className="text-sm font-heading font-bold mt-0.5 line-clamp-2 min-h-[2.25rem]">
            {oli?.name}
          </h3>
        </div>


        <div className="mb-4">
          <p className="text-xs text-muted-foreground line-clamp-2 mb-2">
            {oli?.description}
          </p>
          
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Package" size={16} color="var(--color-muted-foreground)" />
            <span className="text-xs text-muted-foreground">Kode: {oli?.oliCode}</span>
          </div>

          {oli?.warranty && (
            <div className="flex items-center space-x-2">
              <Icon name="Award" size={16} color="var(--color-primary)" />
              <span className="text-xs text-foreground font-medium">{oli?.warranty}</span>
            </div>
          )}
        </div>

        <div className="flex items-center justify-between mb-3 pb-3 border-b border-border">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Harga</p>
            <p className="text-base md:text-lg font-heading font-bold text-primary">
              {formatPrice(oli?.price)}
            </p>
          </div>
          {/* <div className="text-right">
            <p className="text-xs text-muted-foreground mb-1">Stok</p>
            <p className={`text-sm font-heading font-bold ${oli?.stock > 10 ? 'text-success' : oli?.stock > 0 ? 'text-warning' : 'text-error'}`}>
              {oli?.stock > 0 ? `${oli?.stock} unit` : 'Habis'}
            </p>
          </div> */}
        </div>

        <div className="space-y-1.5">
          <Button
            variant="default"
            size="sm"
            fullWidth
            iconName="MessageCircle"
            iconPosition="left"
            onClick={() => onConsult(oli)}
            disabled={oli?.stock === 0}
          >
            Konsultasi
          </Button>
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName="Info"
            iconPosition="left"
            onClick={() => onViewDetails(oli)}
          >
            Detail Produk
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OliCard;